<div class="form-container edit-profile">
  <form [formGroup]='editProfileForm' autocomplete="off">

    <div class="col-12 grid">

      <div class="col-3">
        <img style="width:100%" [src]="profileUrl" onerror="src='/assets/images/temp/default_profile.png'" />
        <div class='display-image profile-btn'>
          <app-file-uploader (onFileUpload)="onUploadProfileImage($event)" accept="image/*"
            [uploadButtonLabel]="chooseLabel"></app-file-uploader>
          <span class="max-limit-doc">( Maximum upload file size: 18 MB )</span>
        </div>
      </div>

      <div class="col-9 grid">
        <div class="form-field col-12 md:col-6 lg:col-6">
          <div class="form-label">
            <label for="firstName" translate>f_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="firstName" type="text" autocomplete="off" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.firstName.errors  && (editProfileForm.controls.firstName.dirty || editProfileForm.controls.firstName.touched)">
            <div [hidden]="!editProfileForm.controls.firstName.errors.required" translate>
              label_this_is_required
            </div>
            <!-- <div [hidden]="!editProfileForm.controls.firstName.errors.minlength" translate>
              min_length
            </div> -->
            <div [hidden]="!editProfileForm.controls.firstName.errors.maxlength" translate>
              label_max_50_characters_allowed
            </div>
            <div [hidden]="!editProfileForm.controls.firstName.errors.pattern" translate>
              common_name_regex_error
            </div>
          </div>
        </div>

        <div class="form-field col-12 md:col-6 lg:col-6">
          <div class="form-label">
            <label for="lastName" translate>l_name</label>
            <label class="asterisk">*</label>
          </div>
          <div class="form-control">
            <input formControlName="lastName" type="text" autocomplete="off" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.lastName.errors  && (editProfileForm.controls.lastName.dirty || editProfileForm.controls.lastName.touched)">
            <div [hidden]="!editProfileForm.controls.lastName.errors.required" translate>
              label_this_is_required
            </div>
            <!-- <div [hidden]="!editProfileForm.controls.lastName.errors.minlength" translate>
              min_length
            </div> -->
            <div [hidden]="!editProfileForm.controls.lastName.errors.maxlength" translate>
              label_max_50_characters_allowed
            </div>
            <div [hidden]="!editProfileForm.controls.lastName.errors.pattern" translate>
              common_name_regex_error
            </div>
          </div>
        </div>

        <div class="form-field col-12 md:col-12 lg:col-12">
          <div class="form-label">
            <label for="email" translate>email</label>
          </div>
          <div class="form-control">
            <input formControlName="email" type="text" autocomplete="off" pInputText />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.email.errors  && (editProfileForm.controls.email.dirty || editProfileForm.controls.email.touched)">
            <!-- <div [hidden]="!editProfileForm.controls.email.errors.required" translate>
              label_this_is_required
            </div> -->
            <div [hidden]="!editProfileForm.controls.email.errors.pattern" translate>
              email_pattern
            </div>
          </div>
        </div>

        <div class="form-field col-5 md:col-5 lg:col-5">
          <div class="form-label">
            <label for="phone" translate>label_country_code</label>

          </div>
          <div class="form-control">
            <p-dropdown [options]="countryCodeList" formControlName="phoneCode" (onChange)="checkCountryCode($event)"
              [filter]="true"> </p-dropdown>
          </div>
          <div class="form-errors" *ngIf="editProfileForm.controls.phoneCode.errors">
            <div [hidden]="!editProfileForm.controls.phoneCode.errors.required" translate>
              label_this_is_required
            </div>
          </div>
        </div>

        <div class="form-field col-7 md:col-7 lg:col-7">
          <div class="form-label">
            <label for="phone" translate>phone</label>
            <span class="information-icon" [title]="'title_zero_not_allow_at_start' | translate"><i
                class="fa fa-info-circle" aria-hidden="true"></i></span>

          </div>
          <div class="form-control">
            <input formControlName="phone" type="text" autocomplete="off" pInputText
              (keyup)="checkCountryCode($event)" />
          </div>
          <div class="form-errors"
            *ngIf="editProfileForm.controls.phone.errors  && (editProfileForm.controls.phone.dirty || editProfileForm.controls.phone.touched)">
            <div [hidden]="!editProfileForm.controls.phone.errors.pattern" translate>
              error_invalid_phone_number_common
            </div>
            <!-- <div [hidden]="!editProfileForm.controls.phone.errors.minlength" translate>
              min_length_phone_number
            </div>
            <div [hidden]="!editProfileForm.controls.phone.errors.maxlength" translate>
              max_length_phone_number
            </div> -->
          </div>
        </div>

        <div class="form-buttons col-12 ">
          <button pButton appRipple type="button" [label]="'label_save' | translate"
            [disabled]="!editProfileForm.valid || isSaving" [loading]="isSaving" (click)="updateProfile($event)"></button>
          <button class="negative-button" pButton appRipple type="button" [label]="'label_cancel' | translate"
            (click)="closeEditProfile($event)"></button>
          <!-- icon="fa fa-close" -->
        </div>
      </div>
    </div>
  </form>
</div>
<!-- p-growl [value]="message"></p-growl -->